<template>
  <LoginEmailConfirmContent
    :sign-in-to="crmSignInTo"
    :fallback-to="crmFallbackTo"
  />
</template>

<script lang="ts" setup>
import LoginEmailConfirmContent from './LoginEmailConfirmContent.vue';

const crmSignInTo = { name: 'UserSignin' };
const crmFallbackTo = { name: 'Cockpit' };
</script>
